import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

interface CreateCommunityDraft {
	name: string;
	slug: string;
	description?: string;
}

interface OnboardingState {
	createCommunityDraft: CreateCommunityDraft | null;
}

const initialState: OnboardingState = {
	createCommunityDraft: null,
};

export const onboardingSlice = createSlice({
	name: "onboarding",
	initialState,
	reducers: {
		setCreateCommunityStep1: (state, action: PayloadAction<CreateCommunityDraft>) => {
			state.createCommunityDraft = action.payload;
		},
		clearDraft: (state) => {
			state.createCommunityDraft = null;
		},
	},
});

export const { setCreateCommunityStep1, clearDraft } = onboardingSlice.actions;
